import { TRAVEL_COLORS } from '../constants/travel-colors';

/** Свободный цвет группы; после палитры оттенки продолжаются по кругу. */
export function nextTravelColor(colors: Iterable<string>): string {
  const taken = new Set([...colors].map((color) => color.toLowerCase()));
  const free = TRAVEL_COLORS.find((color) => !taken.has(color.hex));
  if (free) return free.hex;
  const hue = Math.round(((taken.size * 137.508) % 360 + 360) % 360);
  return hslToHex(hue, 55, 62);
}

function hslToHex(h: number, s: number, l: number): string {
  const a = (s / 100) * Math.min(l / 100, 1 - l / 100);
  const part = (n: number) => {
    const k = (n + h / 30) % 12;
    const value = l / 100 - a * Math.max(-1, Math.min(k - 3, Math.min(9 - k, 1)));
    return Math.round(255 * value).toString(16).padStart(2, '0');
  };
  return `#${part(0)}${part(8)}${part(4)}`;
}
